import { useGroupGuid } from '../components/IAP/hooks/commonHooks';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import apiConfig from '../constants/apiConfig';
import { AORsByHierarchyLevelPayload } from '../components/MapPage/CorporateViewTabs/AorsTab/utils/schema';

const keys = {
  base: 'aorsByHierarchy',
  list: (groupGuid: string | undefined) =>
    [keys.base, groupGuid ?? ''] as const,
} as const;

const getAorsByHierarchy = async (groupGuid: string) => {
  const response = await axios.get<AORsByHierarchyLevelPayload>(
    apiConfig.apiGateway.getAorsByHierarchy(groupGuid)
  );
  return response.data;
};

export const useGetAorsByHierarchy = () => {
  const groupGuid = useGroupGuid();
  return useQuery({
    queryKey: keys.list(groupGuid),
    queryFn: () => getAorsByHierarchy(groupGuid),
    enabled: Boolean(groupGuid),
  });
};
